<template>
  <footer id="footer">
    <div class="footer-holder">
      <div class="logo-holder">
        <strong class="logo">Mobidev | Design team</strong>
      </div>
      <ul class="footer-nav">
        <li
          v-for="(item, index) in navigationMenu"
          :key="item.id"
          class="footer-nav-link"
        >
          <router-link :to="item.path">
            {{ item.title }}
            <span class="footer-menu-counter">{{ index + 1 }}</span>
          </router-link>
        </li>
      </ul>
      <div class="contacts-holder">
        <h5>CONTACTS</h5>
        <address>
          <div class="address">
            <b>US Office - MobiDev Corporation</b>
            <p>3855 Holcomb Bridge Rd. Suite 300, <br />Norcross, GA 30092, USA</p>
          </div>
          <div class="address">
            <b>UK Office - MobiDev International Ltd</b>
            <p>311 Shoreham Street,<br /> Sheffield, South Yorkshire S24FA, England</p>
          </div>
          <div class="address">
            <b>R&amp;D centers</b>
            <span> - Lodz (Poland), Chernivtsi (Ukraine)</span>
          </div>
          <div class="phone">
            <b><a href="tel:+48790675136">+48 790 675 136</a></b><span> (EU)</span><br />
            <b><a href="tel:+12679446127">+1 267 944 6127</a></b><span> (USA/Canada)</span><br />
            <span>Call us </span><b>10 a.m. - 7 p.m.</b>
          </div>
          <div class="email">
            <b><a href="mailto:business@mobidev.biz">business@mobidev.biz</a></b>
          </div>
        </address>
        <social/>
      </div>
    </div>
    <span class="copy">Copyright &copy; {{ year }} Mobidev. All Rights Reserved.</span>
  </footer>
</template>

<script>
import Social from '@/components/Social';
import { mapState, mapMutations } from 'vuex';
import uuidv4 from 'uuid/v4';


export default {
  data() {
    return {
      navigationMenu: [
        {
          id: uuidv4(),
          path: '/main',
          title: 'Main',
          theme: 'white',
        },
        {
          id: uuidv4(),
          path: '/portfolio',
          title: 'Portfolio',
          // theme: 'white',
        },
        {
          id: uuidv4(),
          path: '/team',
          title: 'Team',
        },
        // {
        // id: uuidv4(),
        // path: '/resources',
        // title: 'Resources',
        // },
        {
          id: uuidv4(),
          path: '/process',
          title: 'Process',
        },
        {
          id: uuidv4(),
          path: '/expertise',
          title: 'Expertise',
        },
      ],
    };
  },
  computed: {
    year() {
      return (new Date()).getFullYear();
    },
    ...mapState({
      visible: 'modalVisible',
      modalComponent: 'modalComponent',
    }),
  },
  methods: {
    ...mapMutations(['showModal']),
  },
  components: {
    social: Social,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UI/Footer.vue